import React from 'react'
import PropTypes from 'prop-types'

const SimpleInputField = props => {
    const { id = '', value = '', placeholder, type = '', onChange, disabled = false, testid = '', classes = '', propid } = props
    // const { onChange } = events

    return (
        <>
            <div className={`flex flex-row items-center border-1 border-base rounded divide-base align-middle bg-gray-5 focus:bg-white ${classes}`} >
                {type === 'currency' ? <span className="pl-3 text-gray-700">$</span> : null}
                <input data-propid={propid} data-testid={testid} id={id} value={value} onChange={onChange} disabled={disabled} className={`form-control border-0 ${type === 'currency' ? 'pl-2' : ''}`}
                    type="text" placeholder={placeholder} />
                {type === 'percent' ? <span className="px-2 text-gray-700">%</span> : null}
            </div>
        </>
    )
}

export default SimpleInputField

SimpleInputField.propTypes = {
    id: PropTypes.string,
    propid: PropTypes.string,
    testid: PropTypes.string,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    onChange: PropTypes.any,
    disabled: PropTypes.bool,
    classes: PropTypes.string
}
